export default function SMEPrivacyPolicyRAView() {
  return {
      view: (vnode) => {

          const { onChangeAccept } = vnode.attrs;

          return m("table[cellpadding='2'][cellspacing='2'][border='0'][width='100%']",
              m("tbody",
                  m("tr",
                      m("td[bgcolor='#EEEEEE']",
                          m("table[border='0'][cellpadding='2'][cellspacing='2'][width='100%']",
                              m("tbody",
                                  m("tr[bgcolor='#0099ff']",
                                      m("td",
                                          m("h3", "SAMSUNG e-WARRANTY INCENTIVE PROGRAM (Terms & Conditions)")
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("br"),
                                          m("b", "1. Duration of e-Warranty Incentive Programme")
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          "This e-Warranty Incentive Programme (\"",
                                          m("b",
                                              "Programme"
                                          ),
                                          "\") will be valid for a period o year commencing fro, 2013 t. Samsung Malaysia Electronics (SME) Sdn Bhd(Company No. 629186-D) (\"",
                                          m("b",
                                              "Samsung"
                                          ),
                                          "\") reserves its absolute right to extend or end this Programme at any time."
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("br"),
                                          m("b", "2. Scope of e-Warranty Incentive Programme:")
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          "This Programme shall be applicable to all retail shops and sales personnel that are selling Samsung products and are registered in this Programme. In order to participate in the said Programme, the Retail Assistant (\"",
                                          m("b",
                                              "RA"
                                          ),
                                          "\") is required to complete and submit the Customer’s information as required by the prescribed application form to Samsung."
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("br"),
                                          m("b", "3. Incentive Calculation Principles")
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("ul",
                                              m("li",
                                                  "On each successful submission under the Programme, the RA will be entitled to an incentive (\"",
                                                  m("b",
                                                      "e-Warranty Incentive"
                                                  ),
                                                  "\") provided that the RA complies with all and does not breach any of the terms and conditions herein."
                                              ),
                                              m("li",
                                                  "The e-Warranty Incentive will be calculated based on the successful registration of warranties of products purchased by the Customer using the methods prescribed by Samsung in particular, the Marketing Communication System Portal (\"",
                                                  m("b",
                                                      "MCS Portal"
                                                  ),
                                                  "\") and/or e-Warranty Mobile Application, during the validity period of this Programme. The amount payable under the e-Warranty Incentive will be solely determined by Samsung and may subject to change throughout the valid period of the Programme."
                                              ),
                                              m("li",
                                                  "The RA shall not prescribe any unethical method in capturing Customer’s registration including but not limited to: ",
                                                  m("ul",
                                                      m("li",
                                                          "fraud;"
                                                      ),
                                                      m("li",
                                                          "negligent;"
                                                      ),
                                                      m("li",
                                                          "misrepresentation;"
                                                      ),
                                                      m("li",
                                                          "omission; or"
                                                      ),
                                                      m("li",
                                                          "creating dummy accounts."
                                                      )
                                                  )
                                              ),
                                              m("li", "In the event that Samsung discovers that the RA employed such methods in capturing registration, at Samsung’s option, the RA shall refund to Samsung or deduct the amount of incentive paid or payable to the RA. This right shall be in addition to Samsung's rights under this Agreement to terminate this Agreement."),
                                              m("li", "The RA shall ensure that the customer's information are collected, processed and procured in a lawful manner. The RA shall be under obligation to protect such information from unauthorized and/or accidental access, unauthorized processing, deletion, alteration, disclosure or destruction of such information and shall be responsible to take all and every security measures deemed necessary for execution of this obligation.")
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b", "4. Incentive payment procedure:")
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("ul",
                                              m("li", "On a monthly basis, total incentive amount will be calculated and the RA will be informed of the same. Samsung will pay the incentive amount to the RA via its appointed payment agent into the RA's bank account provided to Samsung."),
                                              m("li",
                                                  "Samsung reserves its right to reject or refuse any information submitted by the RA if such submission is invalid due to, but not limited to, the following situations: ",
                                                  m("ul",
                                                      m("li", "the RA activated the e-Warranty Programme before selling the Product to the Customer;"),
                                                      m("li", "IMEI was already used or had been activated before; and"),
                                                      m("li", "RA did not submit the required information within the period prescribed by Samsung.")
                                                  )
                                              ),
                                              m("li",
                                                  "In addition, if the RA is found to be in violation of the situations as mentioned in Clause 4(2) above, Samsung shall be entitled to impose a penalty to deduct or set-off the e-Warranty Incentive based on the rates below: ",
                                                  m("ul",
                                                      m("li", "First offence - 50% of total weekly e-Warranty Incentive"),
                                                      m("li", "Second offence - 100% of the weekly e-Warranty Incentive; and"),
                                                      m("li", "Third offence and above - 100% of the monthly e-Warranty Incentive or immediate termination of this Agreement.")
                                                  )
                                              )
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b", "5. Use of MCS Portal and e-Warranty Mobile Application")
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("ul",
                                              m("li", "Subject to the compliance of the terms and conditions herein, Samsung grants the RA a non-exclusive, non-transferable licence, without the right to sublicense, to use and access the MCS Portal and/or e-Warranty Mobile Application."),
                                              m("li", "The RA shall adhere to any terms and conditions imposed for the use of the MCS Portal and/or e-Warranty Mobile Application."),
                                              m("li", "The RA shall be under obligation to protect the account assigned by Samsung at all times from unauthorized and/or accidental access and/or unauthorized use and to promptly notify Samsung if it suspects any unauthorized use of said the account."),
                                              m("li",
                                                  "Samsung reserves the rights to suspend or restrict the RA to use or access the MCS Portal and/or the e-Warranty Mobile Application if the RA does the following: ",
                                                  m("ul",
                                                      m("li", "misuses the MCS Portal or the e-Warranty Mobile Application;"),
                                                      m("li", "commits fraudulent or unauthorized access;"),
                                                      m("li", "tampers with the registration process; or"),
                                                      m("li", "commits any activities that are inconsistent with the uses the MCS Portal or the e-Warranty Mobile Application.")
                                                  )
                                              ),
                                              m("li", "Samsung reserves the right to modify, suspend, or discontinue the MCS Portal and/or e-Warranty Mobile Application(or any part or content thereof) at any time with or without notice, and Samsung will not be liable to the RA or to any third party should it exercise such rights."),
                                              m("li", "Samsung also reserves the right at any time to modify this Agreement and to impose new or additional terms or conditions on the use of the MCS Portal and/or e-Warranty Mobile Application. Such modifications and additional terms and conditions will be effective immediately and incorporated into this Agreement. The continued use of the MCS Portal and e-Warranty Mobile Application will be deemed acceptance thereof. If the RA refuses or rejects any such modifications and additional terms and conditions, this Agreement shall be terminated immediately.")
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b", "6. Right to change, vary or amend the Programme")
                                      )
                                  ),
                                  m("tr",
                                      m("td", "Samsung shall reserve its rights to change, vary or amend the Programme without any notification to you.")
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b",
                                              m("br"),
                                              "7. Confidentiality"
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("ul",
                                              m("li", "All information learned or obtained in the course of work of this Programme which includes the Customer's information shall be deemed to be strictly confidential. No such information shall be divulged to any third party."),
                                              m("li", "The RA shall at all times ensure confidentiality of Samsung's proprietary and other confidential information whether such information is directly or indirectly within RA's knowledge. Such information which shall continue to remain as the property of Samsung and shall not be divulged to any third party without the expressed authority of Samsung.")
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b", "8. Termination"
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("ul",
                                              m("li", "Samsung shall be entitled to terminate this Agreement immediately should there be any breach by the RA of the terms and conditions of this Agreement."),
                                              m("li", "Notwithstanding the preceding paragraph, Samsung and/or the RA shall be entitled to terminate this Agreement without assigning any reason by providing seven (7) business days prior written notice.")
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b", "9. Indemnity")
                                      )
                                  ),
                                  m("tr",
                                      m("td", "The RA shall fully indemnify Samsung for any and all claims liabilities damage and/or expenses incurred or sustained by Samsung for any loss and/or damage sustained by Samsung.")
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b",
                                              m("br"),
                                              "10. Disclaimer of liability"
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td", "Samsung shall disclaim all liabilities in respect of any fraud or negligence incidents or non-receipt of payment by the RA or any liabilities whatsoever that may arise from this Programme.")
                                  ),
                                  m("tr",
                                      m("td",
                                          m("br"),
                                          m("br")
                                      )
                                  ),
                                  m("tr[bgcolor='#0099ff']",
                                      m("td",
                                          m("h3", "SAMSUNG e-WARRANTY INCENTIVE PROGRAM (Privacy Policy)")
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("br"),
                                          "When you submit the application form, ",
                                          m("b", "Samsung Malaysia Electronics (SME) Sdn Bhd"),
                                          " (Company No. 629186-D) (hereinafter referred as \"",
                                          m("b", "Samsung"),
                                          "\" or \"",
                                          m("b", "We"),
                                          "\" or \"",
                                          m("b", "Us"),
                                          "\" or \"",
                                          m("b", "Our"),
                                          "\") will be processing your information."
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b",
                                              m("br"),
                                              "A. COLLECTION OF INFORMATION"
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          "We collect personal information such as your name, address, contact details, bank account details and your place of work when you register with us to subscribe to the e-Warranty Incentive Programme (“",
                                          m("b", "Programme"),
                                          "”) and/or when you use our electronic portals such as our short messaging services portal, Marketing Communication System (MCS) Portal and/or e-Warranty Mobile Application (collectively referred as the “",
                                          m("b", "Portal"),
                                          "”).",
                                          m("br"),
                                          m("br"),
                                          " The personal information required herein (unless stated otherwise) is obligatory on you and if you fail to provide any information as required, it may affect your application to the Programme.",
                                          m("br"),
                                          m("br"),
                                          " We may also process other personal information such as:- ",
                                          m("ul",
                                              m("li", "your activities through the Portal,"),
                                              m("li", "information collected through the use of Cookies (as defined below).")
                                          ),
                                          " Some of the information collected by us may not be explicitly submitted by you as we also automatically receives and records information on its server logs from your browser, including your internet protocol (IP) address, cookie information, the web pages you request, your browser type and language, access times, and the referring web site address. "
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b",
                                              m("br"),
                                              "B. COOKIES"
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td", "\"Cookies\" are data files that may be downloaded to your computer when you visit the Portal and permit the Portal to identify your browser whenever you interact with the Portal. We use cookies to recognize repeat visits by users and to collect information about our users’ interactions with the Portal. These cookies contain identification information that enables us to streamline your experiences using the Portal. You may set your browser software to reject cookies, but you may not be able to optimize the features of the Portal. In some cases, you may not be able to access the Portal if cookies are disabled.")
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b",
                                              m("br"),
                                              "C. USE OF PERSONALLY IDENTIFYING INFORMATION"
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td", "In general, we may use the information provided to us for the following purposes:-")
                                  ),
                                  m("tr",
                                      m("td",
                                          m("ul",
                                              m("li", "to register you with the Portal;"),
                                              m("li", "to make any payment in relation to your services to us;"),
                                              m("li", "manage your account and provide you with support;"),
                                              m("li", "enforce any Terms and Conditions between us;"),
                                              m("li", "research purposes including historical and statistical purposes;"),
                                              m("li", "general operation and maintenance of the Portal including audit and its related portal(s);"),
                                              m("li", "provide you with regular communications from us relating to the e-Warranty Programme and the Portal; and"),
                                              m("li", "investigation of complaints, suspected suspicious transactions and research for service improvement.")
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b", "D. DISCLOSURE OF PERSONALLY IDENTIFYING INFORMATION")
                                      )
                                  ),
                                  m("tr",
                                      m("td")
                                  ),
                                  m("tr",
                                      m("td",
                                          m("ul",
                                              m("li",
                                                  "We may share your personal information with:- ",
                                                  m("ul",
                                                      m("li", "your employer;"),
                                                      m("li", "service providers under contract who help with our business operations (such as fraud investigations, bill collection, monitoring of user behaviour on the Portal and the processing of payments for any products or services);"),
                                                      m("li", "third parties (including those overseas) who provide data processing services;"),
                                                      m("li", "any credit reference agencies or, in the event of default, any debt collection agencies; and"),
                                                      m("li", "any person, who is under a duty of confidentiality to which has undertaken to keep such data confidential, which we have engaged to fulfill our obligations to you.")
                                                  )
                                              ),
                                              m("li", "We may disclose your personal information if required to do so by law or if we have good faith belief that such disclosure is necessary to protect and/or defend our rights and interests. We may, as permitted by applicable law, disclose your personally identifiable information to third parties in connection with an investigation of fraud, infringement, piracy, tax avoidance and evasion or other unlawful activity and you expressly authorize us to make such disclosures."),
                                              m("li", "Merger or Acquisition. If we are merged or acquired by another entity, personally identifiable information may be transferred to such entity as a part of the merger or acquisition.")
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b", "E. TRANSFER OF PERSONAL DATA OVERSEAS")
                                      )
                                  ),
                                  m("tr",
                                      m("td", "During the term of the Programme and when you are using the Portal, it may be necessary for us to forward personal information to relevant overseas third party service providers. We will only make such transfer if it is allowed by our data protection laws.")
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b",
                                              m("br"),
                                              "F. REVIEW AND MODIFICATIONS TO YOUR PERSONALLY IDENTIFYING INFORMATION"
                                          )
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          " If you would like to make any inquiries or complaints or request access or correction of the personal data, please contact at the address below:-",
                                          m("br"),
                                          m("br"),
                                          " Address: Suite E-09-01, Level 9, East Wing, ICON Tun Razak 50400 Kuala Lumpur. ",
                                          m("br"),
                                          m("br"),
                                          " Email",
                                          m("br"),
                                          " Telephone No: 03-2165 0000",
                                          m("br"),
                                          " Fax No:",
                                          m("br"),
                                          m("br"),
                                          " Any request of access of correction of personal data may subject to a fee and also to any privacy or data protection laws.",
                                          m("br"),
                                          m("br"),
                                          " However, we reserve the right to decline to process requests which jeopardize the security and privacy of the personal data of others as well as requests which are impractical or not made in good faith.",
                                          m("br"),
                                          m("br"),
                                          " Where you elect to limit our right to process the personal data, you may contact us in writing. For avoidance of doubt, the limitation does not include processing of mandatory personal data.",
                                          m("br"),
                                          m("br")
                                      )
                                  ),
                                  m("tr",
                                      m("td",
                                          m("b", "G. CHANGES TO THIS POLICY")
                                      )
                                  ),
                                  m("tr",
                                      m("td", "Samsung may change and update this Privacy Policy from time to time. Samsung will notify you of any material changes or additions to this Privacy Policy and will provide you with a copy of the amended Privacy Policy, either by email or by any other suitable means which ensure that you will be able to take notice of the changes to this Privacy Policy.")
                                  ),
                                  m("tr",
                                      m("td",
                                          m("br"),
                                          "DatedInsert date]"
                                      )
                                  )
                              )
                          )
                      )
                  )
              ),
              m("table[border='0'][cellpadding='2'][cellspacing='2'][width='100%']",
                  m("tbody",
                      m("tr",
                          m("td",
                              m("input[type='checkbox'][id='chkAccept'][name='chkAccept']", {
                                  onchange: onChangeAccept
                              }),
                              " By submitting this application, I/we confirm that I/we have read the TERMS & CONDITIONS and I/we accept all the terms and conditions therein. "
                          )
                      )
                  )
              )
          )
      }
  }
}
